import {useDeleteReports} from '@app/reports/requests/use-delete-reports';
import {useDialogContext} from '@ui/overlays/dialog/dialog-context';
import {ConfirmationDialog} from '@ui/overlays/dialog/confirmation-dialog';
import {Trans} from '@ui/i18n/trans';
import {toast} from '@ui/toast/toast';
import {message} from '@ui/i18n/message';
import React from 'react';
import {useTrans} from '@ui/i18n/use-trans';
import {queryClient} from '@common/http/query-client';
import {DatatableDataQueryKey} from '@common/datatable/requests/paginated-resources';
import {Nzb} from '@app/titles/models/nzb';
import {Lien} from '@app/titles/models/lien';

export function DeleteReportDialog({item}: {item: Lien | Nzb}) {
  const deleteReport = useDeleteReports(item.model_type);
  const {close} = useDialogContext();
  const {trans} = useTrans();
  return (
    <ConfirmationDialog
      title={
        item.model_type === 'nzb' ? (
          <Trans message="Delete all nzbs reports" />
        ) : (
          <Trans message="Delete all liens reports" />
        )
      }
      body={<Trans message="Are you sure you want to delete this reports?" />}
      confirm={<Trans message="Delete" />}
      onConfirm={() =>
        deleteReport.mutate(
          {id: item.id, delete: true},
          {
            onSuccess: () => {
              toast(trans(message('Report deleted')));
              queryClient.invalidateQueries({
                queryKey: DatatableDataQueryKey(
                  item.model_type === 'nzb' ? 'nzb' : 'liens',
                  {
                    loader: 'adminliens',
                    reported: 1,
                  },
                ),
              });
              close();
            },
          },
        )
      }
      isLoading={deleteReport.isPending}
      isDanger
    />
  );
}
